import { Component } from '@angular/core';
import { AppService } from '../shared/services/app.service';
import { BaseService } from '../shared/services/base.service';

@Component({
    selector: 'kx-404-component',
    templateUrl: '404.component.html',
    standalone: false
})
export class P404Component {

  constructor(
    private appService: AppService,
    private baseService: BaseService
  ) { }

  ngOnInit() {
    if (!this.appService.getSessionId()) {
      this.baseService.logout();
    }
  }
}
